import { render } from "./TopPlayers.vue?vue&type=template&id=68c3e238"
import script from "./TopPlayers.vue?vue&type=script&lang=js"
export * from "./TopPlayers.vue?vue&type=script&lang=js"

import exportComponent from "/root/logs/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__